module.exports = __webpack_public_path__ + "wf.svg?a10487a62b8516b7d842cfb1bcf9489f";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/1x1/wf.svg
// module id = 1695
// module chunks = 0